export type UserManagementListActiveViewType =
  | "users"
  | "service-users"
  | "gateway-service-users";

export type UserUpdatableStatus = "ACTIVE" | "INACTIVE" | "INITIAL" | null;

export type ISO3LanguageCode =
  | "eng"
  | "deu"
  | "zho"
  | "ita"
  | "spa"
  | "por"
  | "nld"
  | "tur";

export enum ZitadelUserType {
  SERVICE_GATEWAY = "SERVICE_GATEWAY",
  SERVICE_API = "SERVICE_API",
  HUMAN = "HUMAN",
}

export type Role = string;

export interface ZitadelUser {
  id?: string;
  type: ZitadelUserType.HUMAN;
  status: UserUpdatableStatus;
  email: string;
  email_is_verified: boolean;
  username: string;
  given_name: string;
  family_name: string;
  nickname: string;
  language: ISO3LanguageCode;
  chosen_timezone: string | null;
  roles: string[];
  display_name?: string;
  created_at: string;
  updated_at: string;
  preferred_login_name: string;
  login_names: string[];
}

export interface ZitadelServiceUser {
  id?: string;
  type: ZitadelUserType.SERVICE_API;
  status: UserUpdatableStatus;
  username: string;
  name: string;
  description: string;
  roles: string[];
  expiration_date: string;
  created_at: string;
  updated_at: string;
  preferred_login_name: string;
  login_names: string[];
}
export type ZitadelGatewayServiceUser = Omit<ZitadelServiceUser, "type"> & {
  type: ZitadelUserType.SERVICE_GATEWAY;
};

export interface PostOrPatchUserDto {
  email: string;
  username: string;
  given_name: string;
  family_name: string;
  language: ISO3LanguageCode;
  chosen_timezone: string;
  roles: string[];
}

export interface PostOrPatchServiceUserDto {
  username: string;
  name: string;
  description?: string;
  roles: string[];
  expiration_date: string;
}

export interface UserCredentials {
  id: string;
  key_id: string;
  private_key: string;
  expiration_date: string;
}

export interface ZitadelServiceUserWithCredentials extends ZitadelServiceUser {
  key_id?: string;
  private_key?: string;
}

export enum UserManagementListActiveRoleEnum {
  USERS = "users",
  SERVICE_USERS = "service-users",
  GATEWAY_SERVICE_USERS = "gateway-service-users",
}

export type UserManagementListActiveRoleRenderDataType =
  | ZitadelUser[]
  | ZitadelServiceUser[]
  | ZitadelGatewayServiceUser[];
